import { FormHelperText } from "@mui/material";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import RadioGroup from "@mui/material/RadioGroup";
import { getIn, useField, useFormikContext } from "formik";
import React, { useEffect } from "react";

const FormikRadio = (props) => {
  const [field, meta] = useField(props);
  const { values } = useFormikContext();
  const fieldValue = getIn(values, props.name);

  useEffect(() => {
    if (props.callBack) {
      props.callBack(fieldValue);
    }
  }, [fieldValue]);

  return (
    <FormControl
      component="fieldset"
      error={meta.touched && meta.error ? true : false}
      disabled={props.disabled}
    >
      <FormLabel component="legend">{props.label}</FormLabel>
      <RadioGroup
        name={props.name}
        value={props.value}
        row={props.row}
        {...props.groupProps}
        {...field}
      >
        {props.children}
      </RadioGroup>
      <FormHelperText>
        {meta.touched && meta.error ? meta.error : null}
      </FormHelperText>
    </FormControl>
  );
};

export default FormikRadio;
